import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sales-channel q-mb-md"
}
const _hoisted_2 = { class: "left col-sm-12 col-md-6" }
const _hoisted_3 = {
  key: 0,
  class: "row items-center q-gutter-sm"
}
const _hoisted_4 = { class: "channel-link-title" }
const _hoisted_5 = { class: "right col-sm-12 col-md-6" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_channel_service_link = _resolveComponent("channel-service-link")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_multi_switch = _resolveComponent("multi-switch")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_event_config_editor = _resolveComponent("event-config-editor")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_channel_service_link, {
      catalogue: _ctx.catalogue,
      "onUpdate:catalogue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('update:catalogue', _ctx.catalogue?.sys?.id, $event))),
      modelValue: _ctx.showServiceModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showServiceModal) = $event))
    }, null, 8, ["catalogue", "modelValue"]),
    (!_ctx.catalogue?.service?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_btn, {
            class: "q-mb-none",
            unelevated: "",
            rounded: "",
            color: "primary",
            size: "sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showServiceModal = true)),
            disable: _ctx.readonly
          }, {
            default: _withCtx(() => [
              _createVNode(_component_add_icon, { left: "" }),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Connect an app", -1))
            ]),
            _: 1
          }, 8, ["disable"])
        ]))
      : (_openBlock(), _createBlock(_component_editable_block, {
          key: 1,
          class: "row",
          readonly: _ctx.readonly,
          title: _ctx.catalogue?.service?.id ? 'Linked to App' : 'Link to sales channel',
          "model-value": _ctx.catalogue,
          "remove-scope-style": "",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:catalogue', _ctx.catalogue?.sys?.id, $event))),
          layout: "row"
        }, {
          default: _withCtx(({ editState, editingRef, save }) => [
            _createElementVNode("div", _hoisted_2, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "description q-mb-md" }, [
                _createElementVNode("span", null, "Link this channel to an external app &"),
                _createElementVNode("br"),
                _createElementVNode("span", null, "choose what data will be synced")
              ], -1)),
              (editState.service?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-subtitle" }, "Linked to", -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_q_chip, {
                        color: "white",
                        size: "md"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getServiceAccount(editState.service?.id)) + " — " + _toDisplayString(_ctx.getServiceType(editState.service?.id)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    (editingRef?.value && editState.service?.id)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          color: "primary",
                          size: "md",
                          label: "Unlink",
                          icon: "remove",
                          "no-caps": "true",
                          rounded: "",
                          unelevated: "",
                          onClick: ($event: any) => (_ctx.handleServiceUnlink(editState))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["sync-switches", { 'disable-switches': !editState.service?.id }]),
                  onClick: _withModifiers(() => _ctx.onSyncSwitchesClick(editState, editingRef), ["stop"])
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sync-label" }, "Inventory", -1)),
                  _createVNode(_component_multi_switch, {
                    "model-value": editState.service?.sync?.inventory?.active || 0,
                    "onUpdate:modelValue": ($event: any) => (_ctx.setSync(editState, editingRef, 'inventory', $event)),
                    options: _ctx.syncSwitchOptions,
                    disable: ['pull','both'],
                    readonly: _ctx.readonly
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "readonly"]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sync-label" }, "Products", -1)),
                  _createVNode(_component_multi_switch, {
                    "model-value": editState.service?.sync?.product?.active || 0,
                    "onUpdate:modelValue": ($event: any) => (_ctx.setSync(editState, editingRef, 'product', $event)),
                    options: _ctx.syncSwitchOptions,
                    readonly: _ctx.readonly
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "readonly"]),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "sync-label" }, "Orders", -1)),
                  _createVNode(_component_multi_switch, {
                    "model-value": editState.service?.sync?.order?.active || 0,
                    "onUpdate:modelValue": ($event: any) => (_ctx.setSync(editState, editingRef, 'order', $event)),
                    options: _ctx.syncSwitchOptions,
                    readonly: _ctx.readonly
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "readonly"])
                ], 10, _hoisted_7),
                (!_ctx.readonly)
                  ? _withDirectives((_openBlock(), _createBlock(_component_ozn_button, {
                      key: 0,
                      class: "minimal",
                      label: "Sync options",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showServiceConfig = true))
                    }, null, 512)), [
                      [_vShow, editState.service?.id]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_q_dialog, {
                modelValue: _ctx.showServiceConfig,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showServiceConfig) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card, { style: {"min-width":"70vw","padding":"2.8rem"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_event_config_editor, {
                        "model-value": editState.service,
                        onSave: save,
                        "onUpdate:modelValue": ($event: any) => (editState.service = $event),
                        title: "Sync options"
                      }, null, 8, ["model-value", "onSave", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["readonly", "title", "model-value"]))
  ], 64))
}